import { render, staticRenderFns } from "./editImportantEvent.vue?vue&type=template&id=0faa4c2a&scoped=true&"
import script from "./editImportantEvent.vue?vue&type=script&lang=js&"
export * from "./editImportantEvent.vue?vue&type=script&lang=js&"
import style0 from "./editImportantEvent.vue?vue&type=style&index=0&id=0faa4c2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faa4c2a",
  null
  
)

export default component.exports